'use client';

import { useTableSort } from '@/components/context/tableProvider';
import { TableTh } from '@/components/ui/data-display/tables/TableTh';

export const TableHeading = ({ data }) => {
  const { sortBy, reverseSortDirection, setSorting } = useTableSort();
  return (
    <TableTh
      sorted={sortBy === data?.fields?.title}
      reversed={reverseSortDirection}
      onSort={() => setSorting(data?.fields?.title)}
      data={{
        title: data?.fields?.title,
        colspan: data?.fields?.colspan,
        rowspan: data?.fields?.rowspan,
      }}
    />
  );
};
